module.exports = __webpack_public_path__ + "static/media/accounts-team.ec80ef43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accounts-team.jpg
// module id = 78
// module chunks = 3